<template>
  <PromotionGiftConditionBanner
    v-if="giftPromotion && !areGiftConditionsMet"
    :style="promotionStyle"
    :schedule-to="giftPromotion.schedule.to"
    :label="label"
  />
</template>

<script setup lang="ts">
const props = defineProps<{ basketItem: FimBasketItem }>()

const basketItem = computed(() => props.basketItem)

const {
  giftPromotion,
  promotionStyle,
  minOrderValueLeft,
  quantityLeftForGiftConditions: quantityLeft,
  areGiftConditionsMet,
} = await useBasketItemPromotion(basketItem)

const { label } = usePromotionConditionBanner(minOrderValueLeft, quantityLeft)
</script>
